export const UPDATE_ORDER = 'update_order';
export const ADD_ORDER = 'add_order';
export const REMOVE_ORDER = 'remove_order';
export const GET_ALL_ORDERS = 'get_all_orders';
export const ASSIGN_ORDER = 'assign_order';
export const UPDATE_ORDERS = 'update_orders';
export const FORCE_UPDATE_ORDER = 'force_update_order';
export const CANCEL_ORDER = 'cancel_order';

export const INVALID_ORDERS_UPDATED = 'invalidOrder/fetching';
export const FETCHING_INVALID_ORDERS = 'invalidOrder/fetchComplete';
export const INVALID_ORDERS_COUNT_UPDATED = 'invalidOrder/count';
export const START_INVALID_ORDER_EDIT = 'invalidOrder/edit';
export const END_INVALID_ORDER_EDIT = 'invalidOrder/endEdit';
